import ECGList from './ecg-list';
import './ecg-list.css';

export default ECGList;
